<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<h1>{{doc?.propertiesObj.DocumentTitle}}<span *ngIf="!!doc?.propertiesObj?.ContractDeletedDate" class="deleted"> -
    Deleted</span></h1>
<div class="tabs__control">
  <ul class="inline-list">
    <li>
      Contract Status:
      {{doc?.propertiesObj.ContractStatus | asyncChoiceList:(documentID$ | async).objectStore:'ContractStatuses' | async }}
    </li>
    <li>
      <button matTooltip="Print" mat-icon-button
        [routerLink]="['/',(documentID$ | async).objectStore,'DocumentPrint',(documentID$ | async).id]">
        <mat-icon><img src="assets/images/icon-print.svg" /></mat-icon>
      </button>
    </li>
    <li matTooltip="Edit" *ngIf="doc?.permissions.indexOf('WRITE') >=0">
      <button mat-icon-button
        [routerLink]="['/',(documentID$ | async).objectStore,'documentEdit',(documentID$ | async).id]"
        queryParamsHandling="merge">
        <mat-icon><img src="assets/images/icon-edit.svg" /></mat-icon>
      </button>
    </li>
    <li *ngIf="(document$ | async)?.propertiesObj?.FoldersFiledInID">
      <button matTooltip="Close" mat-icon-button
        [routerLink]="['/',(documentID$ | async).objectStore,'browse',(document$ | async)?.propertiesObj?.FoldersFiledInID]">
        <mat-icon><img src="assets/images/icon-close.svg" /></mat-icon>
      </button>
    </li>
  </ul>
</div>

<mat-tab-group class="tabs__section" (selectedTabChange)="tabClicked($event)" #tabs>
  <mat-tab label="Document Properties">
    <mat-card class="mat-card-sub">
      <app-document-view-properties [doc]="doc" [objectStore]="(documentID$ | async).objectStore">
      </app-document-view-properties>

    </mat-card>
  </mat-tab>
  <mat-tab label="Comments">
    <mat-card class="mat-card-sub" *ngIf="comments$ | async as comments">
      <app-comments-view [addButton]="doc?.permissions.indexOf('WRITE') >=0" [documentID]="doc?.id" [ngModel]="comments"
        [objectStore]="(documentID$ | async).objectStore"></app-comments-view>
    </mat-card>
  </mat-tab>
  <mat-tab label="Linked Documents">
    <mat-card class="mat-card-sub">
      <app-linked-documents-view [objectStore]="(documentID$ | async).objectStore" [ngModel]="linkedDocuments$ | async">
      </app-linked-documents-view>
    </mat-card>
  </mat-tab>
  <mat-tab label="Event Notifications">
    <mat-card class="mat-card-sub">
      <app-event-notification-view *ngIf="doc" [(ngModel)]="doc.alerts"
        [addButton]="doc?.permissions.indexOf('WRITE') >=0" [objectStore]="(documentID$ | async)?.objectStore"
        [document]="doc" [notificationChangedFunction]="notificationChanged">
      </app-event-notification-view>
    </mat-card>
  </mat-tab>
  <mat-tab label="System Alerts">
    <mat-card class="mat-card-sub">
      <app-system-notification-view [alerts]="doc?.alerts" [objectStore]="(documentID$ | async).objectStore"
        [reviewDeadlineDate]="doc?.propertiesObj.ContractReviewDeadlineDate ">
      </app-system-notification-view>
    </mat-card>
  </mat-tab>
  <mat-tab label="Document">
    <mat-card class="mat-card-sub">
      <app-document-view-preview [showAll]="true" [document]="doc" [objectStore]="(documentID$ | async).objectStore">
      </app-document-view-preview>
    </mat-card>
  </mat-tab>
  <mat-tab label="Security">
    <mat-card class="mat-card-sub">
      <app-permissions *ngIf="doc" name="acl" [(ngModel)]="doc.acl" [editMode]="false"></app-permissions>
    </mat-card>
  </mat-tab>
  <mat-tab label="Audit Trail" *ngIf="(userRoles$ | async)?.superUser">
    <mat-card class="mat-card-sub">
      <app-audit-view [audits]="doc?.audits" [objectStore]="(documentID$ | async).objectStore"></app-audit-view>
    </mat-card>
  </mat-tab>
</mat-tab-group>
